import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import PricingPage from "@/pages/PricingPage";
import AdminPage from "@/pages/AdminPage";
import ChatWidget from "@/components/ChatWidget";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/tarifs" element={<PricingPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
        <ChatWidget />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
